const TedEyeIcon = () => (
  <div>
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.08829 7.0024C9.08829 8.1574 8.15495 9.09073 6.99995 9.09073C5.84495 9.09073 4.91162 8.1574 4.91162 7.0024C4.91162 5.8474 5.84495 4.91406 6.99995 4.91406C8.15495 4.91406 9.08829 5.8474 9.08829 7.0024Z"
        stroke="#9E9E9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99991 11.826C9.05908 11.826 10.9782 10.6127 12.3141 8.51271C12.8391 7.69021 12.8391 6.30771 12.3141 5.48521C10.9782 3.38521 9.05908 2.17188 6.99991 2.17188C4.94074 2.17188 3.02158 3.38521 1.68574 5.48521C1.16074 6.30771 1.16074 7.69021 1.68574 8.51271C3.02158 10.6127 4.94074 11.826 6.99991 11.826Z"
        stroke="#9E9E9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default TedEyeIcon;
